export const ANY_DISPO = '#E43A45';
export const PARTIEL_DISPO = '#F1B510';
export const STROKE_DISPO = '#3ED968';
export const IS_SELECT = '#49DB70';
export const IS_DISPO = '#FFFFFF';
export const COLOR_TEXT_DISPO = '#2C3E50';
export const COLOR_VERTICAL_LINE = '#A3A9B5';
export const IS_WEEKEND = '#EFEFEF';
export const ANY_DISPO_WEEKEND = '#D03D47';
export const PARTIEL_DISPO_WEEKEND = '#F18910';
